import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardActionArea,
  CardContent,
} from "@mui/material";
import { Archive, InsertChart, History } from "@mui/icons-material";
import Navbar from "../../../globals/components/Navbar";
import { useNavigate } from "react-router-dom";

const AdminDataManagement = () => {
  const navigate = useNavigate();

  const links = [
    [
      {
        name: "Bond Archives",
        path: "/vermost_bond_archives",
        icon: <Archive fontSize="large" />,
      },
      {
        name: "Analytics",
        path: "/analytics",
        icon: <InsertChart fontSize="large" />,
      },
      {
        name: "Create Historic Bond",
        path: "/bond-creation-outsider-historic",
        icon: <History fontSize="large" />,
      },
    ],
  ];

  return (
    <>
      <Navbar />
      <Box sx={{ padding: 4 }}>
        <Typography variant="h4" fontWeight={800} mb={4} sx={{ color: 'black' }}>
          Data Management
        </Typography>
        <Grid container spacing={3}>
          {links.flat().map((link, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                elevation={3}
                sx={{
                  borderRadius: 3,
                  background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 50%, #f8f9fa 100%)',
                  border: '1px solid rgba(37, 99, 235, 0.2)',
                  transition: "all 0.3s ease-in-out",
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                  "&:hover": {
                    boxShadow: "0 4px 16px rgba(37, 99, 235, 0.15)",
                    background: 'linear-gradient(135deg, #e9ecef 0%, #dee2e6 50%, #e9ecef 100%)',
                    transform: 'translateY(-2px)',
                    borderColor: 'rgba(37, 99, 235, 0.4)',
                  },
                }}
              >
                <CardActionArea onClick={() => navigate(link.path)}>
                  <CardContent
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      padding: 3,
                      color: "#333333",
                    }}
                  >
                    {React.cloneElement(link.icon, { style: { color: '#2563eb' } })}
                    <Typography variant="h6" fontWeight={500} sx={{ color: '#333333' }}>
                      {link.name}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default AdminDataManagement;
